import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import loading from '@/plugs/loading/loading'
import creatLoading from '@/plugs/loading/creatLoading'
import playLoading from '@/plugs/loading/playloading'
import guide from '@/plugs/loading/guide'
import i18n from './locale';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import '@/assets/font/iconfont.css'

import './styles/index.less'
import './styles/variable.less'
// import './mock'

// jsbridge.requestGrant(202502141812067710, 'privateKey')
// console.log(jsbridge);
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import {
    CanvasRenderer
} from 'echarts/renderers'
import {
    BarChart,
    LineChart,
    PieChart,
    ScatterChart,
    RadarChart,
    MapChart,
    TreeChart,
    TreemapChart,
    GraphChart,
    GaugeChart,
    FunnelChart,
    ParallelChart,
    SankeyChart,
    BoxplotChart,
    CandlestickChart,
    EffectScatterChart,
    LinesChart,
    HeatmapChart,
    PictorialBarChart,
    ThemeRiverChart,
    SunburstChart,
    CustomChart
} from 'echarts/charts'
import {
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    GraphicComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    ToolboxComponent,
    BrushComponent,
    TimelineComponent,
    CalendarComponent,
    TitleComponent,
    DatasetComponent,
    TransformComponent,
    VisualMapComponent
} from 'echarts/components'


const app = createApp(App)
app.use(i18n);
app.use(ViewUIPlus, {
    i18n
});
// 注册必需的组件
use([
    CanvasRenderer,
    BarChart,
    LineChart,
    PieChart,
    ScatterChart,
    RadarChart,
    MapChart,
    TreeChart,
    TreemapChart,
    GraphChart,
    GaugeChart,
    FunnelChart,
    ParallelChart,
    SankeyChart,
    BoxplotChart,
    CandlestickChart,
    EffectScatterChart,
    LinesChart,
    HeatmapChart,
    PictorialBarChart,
    ThemeRiverChart,
    SunburstChart,
    CustomChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    GraphicComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    ToolboxComponent,
    BrushComponent,
    TimelineComponent,
    CalendarComponent,
    TitleComponent,
    DatasetComponent,
    TransformComponent,
    VisualMapComponent
])
app.config.unwrapInjectedRef = true
app.config.globalProperties.$Message.config.duration = 5


app.component('v-chart', ECharts)
app.use(router)
    .use(Antd)
    .use(loading)
    .use(creatLoading)
    .use(playLoading)
    .use(guide)
    .use(store)
    .mount('#app')
